import React from "react";
import { isArray, isEmpty } from "lodash";
import { formatHttpsLink } from "../../../../Utils/helperFunction";

const Property = ({
  propertyList,
  isLoggedIn,
  setIsLoginModal,
  handleSelectEvent,
}) => {
  const BlurOverlay = ({ visible, onLoginClick, children }) => {
    return (
      <div className="overlay-container">
        {children}

        {!visible && (
          <div className="blur-overlay" onClick={() => setIsLoginModal(true)}>
            <div className="lock-icon">
              <i
                className="fas fa-lock"
                style={{ color: "#349b52", fontSize: "2rem" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  };
  return !isEmpty(propertyList) ? (
    propertyList?.map((item, index) => {
      const { id, name, image_url, url, address } = item;
      return (
        <div key={id}>
          <BlurOverlay visible={isLoggedIn || isEmpty(propertyList)}>
            <div
              className="event-card-wrap"
              // onClick={() => handleSelectEvent(item)}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (isLoggedIn && url) {
                  window.open(formatHttpsLink(url), "_blank");
                } else if (!isLoggedIn) {
                  setIsLoginModal(true);
                }
              }}
            >
              <img
                src={
                  image_url
                    ? image_url
                    : "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
                }
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "178px",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              />
              <div className="event-card-details-wrap">
                <h2 className="event-card-details-title">{name}</h2>
                {address && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 0px",
                    }}
                  >
                    <img src="/images/location.svg" width={16} />
                    <div className="event-card-details-address"> {address}</div>
                  </div>
                )}

                {url && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 0px",
                    }}
                  >
                    <img src="/images/link-icon.svg" width={16} />
                    <div className="event-card-details-address">
                      <a
                        style={{ textDecoration: "none", color: "#fcfcfc" }}
                        href={formatHttpsLink(url)}
                        target="_blank"
                      >
                        {url}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </BlurOverlay>
        </div>
      );
    })
  ) : (
    <div className="businessDetails-Noreview">
      <img src="/images/calender-icon.svg" />
      <div className="businessDetails-Noreview-content">No Property found.</div>
    </div>
  );
};

export default Property;
